/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.session.SuspendCause
*/
export var SuspendCause;
(function (SuspendCause) {
    SuspendCause["IDLE"] = "IDLE";
    SuspendCause["DISCONNECT"] = "DISCONNECT";
    SuspendCause["FORCED"] = "FORCED";
})(SuspendCause || (SuspendCause = {}));
//# sourceMappingURL=SuspendCause.js.map